import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { forwardRef } from "react";

interface NavigationMenuItemsWrapperDesktopProps {
  children: React.ReactNode;
}

export const NavigationMenuItemsWrapperDesktop = forwardRef<
  HTMLDivElement,
  NavigationMenuItemsWrapperDesktopProps
>((props, ref) => {
  const { tu } = useTu("navigation");
  const { children } = props;

  return (
    <Box
      ref={ref}
      aria-label={tu("Navigation menu")}
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        maxWidth: "300px",
        gap: 1,
        paddingY: 2,
        paddingX: 4,
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        maskImage:
          "linear-gradient(to bottom, transparent, black 16px, black calc(100% - 16px), transparent)",
      }}
    >
      {children}
    </Box>
  );
});
